import { call, put, select, takeEvery } from "redux-saga/effects";
import axios from "../../Utils/AxiosConfig/axiosConfig";
import { LOAD_PREFERENCES, LOAD_PREFERENCES_ERROR, LOAD_PREFERENCES_SUCCESS } from "../Types/preferences.constants";


const getPreferences = async (userId: string) => {
    if (userId) {
        const prefResponse = await axios.get(`preferences/preferencesByUserId/${userId}`);
        return prefResponse.data;
    }
};

export function* listPreferences(): any {
    try {
        const { usersList } = yield select((state) => state);
        const data = yield call(getPreferences, usersList.currentUser._id);

        yield put({
            type: LOAD_PREFERENCES_SUCCESS,
            payload: data
        })
    } catch (error) {
        yield put({
            type: LOAD_PREFERENCES_ERROR,
            payload: null,
        });
    }
};

export function* preferencesSaga() {
    yield takeEvery(LOAD_PREFERENCES, listPreferences);
}


